import { Link } from "react-router-dom";
import { SiteFooter } from "@/components/SiteFooter";

const SECTIONS = [
  {
    title: "The service",
    body: "LocalBusinessJingle.com generates custom jingle previews from your website URL and sells digital audio packages. Previews are provided free of charge, are watermarked, and may not be used publicly, commercially, or redistributed in any form.",
  },
  {
    title: "Purchases & license",
    body: "Upon purchase of a jingle package, you receive a non-exclusive, worldwide, lifetime commercial license to use your chosen master and included cuts in radio, TV, web, social media, advertising, and on-hold audio. You may not resell the raw audio files themselves or claim authorship of the composition.",
  },
  {
    title: "Preview credits",
    body: "Additional preview batches may be purchased for $3. Each $3 payment is credited in full toward a jingle package purchase for the same website. Credits are not refundable, are not redeemable for cash, never exceed the package price, and are tied to the website they were purchased for.",
  },
  {
    title: "Add-ons & upsells",
    body: "Optional add-ons (such as instrumental hold music or the extended radio edition) are licensed under the same terms as the base package once purchased. With your consent at checkout, your card may be charged for add-ons you explicitly approve with one click.",
  },
  {
    title: "Acceptable use",
    body: "You agree not to abuse the free preview system, submit websites you don't own or have permission to represent, or attempt to bypass watermarking or download protection.",
  },
  {
    title: "Refunds & guarantee",
    body: "Because previews are free and heard in full before purchase, sales are final once clean masters are delivered — covered by our Love-It-Or-Don't-Pay Guarantee: preview everything first and pay only if a take sticks.",
  },
  {
    title: "Contact",
    body: "Questions about these terms: jon@getlocalbusinessjingle.com.",
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-obsidian text-white flex flex-col">
      <header className="mx-auto w-full max-w-4xl px-4 sm:px-8 pt-10">
        <Link to="/" data-testid="terms-logo" className="font-display font-extrabold tracking-tight">
          <span className="text-gold">Local</span>Business<span className="text-gold">Jingle</span><span className="text-slate-500">.com</span>
        </Link>
      </header>
      <main className="flex-1 mx-auto w-full max-w-4xl px-4 sm:px-8 py-14">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-4">Legal</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">Terms of Service</h1>
        <p className="text-sm text-slate-500 mb-12">Last updated: September 2026</p>
        <div className="space-y-10">
          {SECTIONS.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-xl font-bold mb-3">{s.title}</h2>
              <p className="text-slate-400 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
